import {Routes} from '@angular/router'
import {authGuard} from './1-application/auth.guard'
import {HOME_PATH, LOGIN_PATH, LOGOUT_PATH} from './0-general/shared'
import {LoginComponent} from './components/login/login.component'
import {Logout} from './components/logout/logout'

/**
 * Note that we permanently ignore this file from
 * coverage since it is just pointless to test
 * imports.
 */
/* v8 ignore next */
export const routes: Routes = [
  {
    path: LOGIN_PATH,
    component: LoginComponent
  },
  {
    path: LOGOUT_PATH,
    component: Logout
  },
  {
    path: HOME_PATH,
    loadComponent: () => import('./components/home/home').then(m => m.Home),
    canActivate: [authGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
]
